export const Const_DifferentialDiagnosis = 'differential-diagnosis';
export const Const_Treatment = 'treatment';
export const Const_ChiefComplaint = 'chief-complaint';
export const Const_Triage = 'triage';
export const pathwayType_SingleState = 'single-state';
export const Const_OrderSet = 'order-set';
export const DiseasePathwayTypes = [Const_DifferentialDiagnosis, Const_Treatment];
export const ComplaintPathwayTypes = [Const_ChiefComplaint, Const_Triage];
export const PathwayTypes = [...DiseasePathwayTypes, ...ComplaintPathwayTypes, pathwayType_SingleState, Const_OrderSet];
export const PathwayVersions = ['3.0.0'];
//# sourceMappingURL=types.js.map